export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"version","content":"1.4.1"},{"name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#50FCEA"},{"name":"color-scheme","content":"dark"}],"link":[{"rel":"preload","type":"font/woff2","href":"/sc/fonts/source-sans-pro_regular-latin.woff2","as":"font","crossorigin":""},{"rel":"preload","type":"font/woff2","href":"/sc/fonts/source-sans-pro_bold-latin.woff2","as":"font","crossorigin":""},{"rel":"icon","type":"image/png","href":"/sc/favicon.png"},{"rel":"preconnect dns-prefetch","href":"https://consent.cookiefirst.com"},{"rel":"dns-prefetch","href":"https://edge.cookiefirst.com"},{"rel":"preconnect dns-prefetch","href":"https://app.varify.io"}],"style":[],"script":[{"innerHTML":"\n(function (w, d, s, l, i) {\n    w[l] = w[l] || [];\n    // Expose gtag globally so CMP callbacks and console-driven debugging\n    // can call gtag('consent', 'update', …) without redefining the stub.\n    w.gtag = w.gtag || function(){w[l].push(arguments);};\n    var gtag = w.gtag;\n    gtag('consent', 'default', {\"ad_storage\":\"denied\",\"analytics_storage\":\"denied\",\"ad_user_data\":\"denied\",\"ad_personalization\":\"denied\",\"wait_for_update\":1500});\n    gtag('set', 'ads_data_redaction', true);\n    // The relaunch cohort from gp_rl, in both builds, so GA4 can split the reports by site_variant.\n    var siteVariant = (d.cookie.match(/(?:^|; *)gp_rl=(new|old)(?:;|$)/) || [])[1];\n    if (siteVariant) {\n      w[l].push({site_variant: siteVariant});\n    }\n    w[l].push({\"gtm.start\": new Date().getTime(), event: 'gtm.js'});\n    var f = d.getElementsByTagName(s)[0],\n        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';\n    j.async = true;\n    j.src =\n        'https://www.googletagmanager.com/gtm.js?id=' + i + dl;\n    j.addEventListener('load', function() {\n      function getCookie(cookieName) {\n        let cookie = {};\n        document.cookie.split(';').forEach(function(el) {\n          let [key,value] = el.split('=');\n          cookie[key.trim()] = value;\n        })\n        return cookie[cookieName];\n      }\n      let ref = getCookie('CakeCookie[ref]');\n      if (!ref) {\n        ref = (new URLSearchParams(window.location.search)).get('ref');\n      }\n      if (ref) {\n        gtag('set', { 'campaign_source': ref, 'campaign_medium': 'affiliate'});\n      }\n    });\n    f.parentNode.insertBefore(j, f);\n  })(window, document, 'script', 'dataLayer', 'GTM-N4BG36H');\n","type":"text/javascript"},{"innerHTML":"\n  window.varify = window.varify || {};\n  window.varify.iid = 2710;\n","type":"text/javascript"},{"src":"https://app.varify.io/varify.js","type":"text/javascript"}],"noscript":[],"title":"GPORTAL"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = false

export const clientNodePlaceholder = true